<template>
    <availability-full-calendar
        :year="year"
        :month="month"
        :dates="dates"
        :physician="physician"
        :practice="practice"
        :showCancelled="false"
    ></availability-full-calendar>
</template>

<script>
    import AvailabilityFullCalendar from 'components/page-elements/availability/AvailabilityFullCalendar'

    export default {
        components: {
            AvailabilityFullCalendar,
        },

        props: {
            year: { type: Number, required: true },
            month: { type: Number, required: true },
            dates: { type: Object, required: true },
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
        },
    }
</script>
